import axios from "axios";

const getJSON = function (url, data, callback, errorHandler) {
  const headers = {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };

  axios({
    method: "post",
    url: url,
    data: data,
    headers: headers,
  })
    .then((b) => {
      if (Object.prototype.hasOwnProperty.call(b, "data")) {
        callback(b.data);
      } else {
        callback(b);
      }
    })
    .catch(errorHandler);
};

export default getJSON;
